<template src="./Index.html">
</template>

<script>


    export default {
        components: {

        },
        created() {
            this.getAll();
            this.$store.dispatch("lookups/getSpecialties")
            this.$store.dispatch("lookups/getUniversities")
            this.$store.dispatch("lookups/getLookups");

        },
        computed: {
            info() {
                return this.$store.state.qualifications.qualifications;
            },
            pageCount() {
                return Math.ceil(
                    this.$store.state.qualifications.totalItems / this.filters.pageSize
                );
            },
            specialties() {
                return this.$store.state.lookups.specialties;

            },
            sourceTypes() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.SourceTypes)

            },
            sources() {
                //return this.$store.state.lookups.universities;
                return this.$store.getters["lookups/getUniversityByType"](this.filters.sourceTypeId)


            },
        },
        data() {
            return {

                dialog: false,
                dialogMessage: null,




                headers: [
                    {
                        text: "المؤهل العلمي",
                        value: "qualificationDetailsName",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "التخصص",
                        value: "specialty",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "نوع مصدر المؤهل",
                        value: "sourceType",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "تاريخ المؤهل",
                        value: "qualificationDate",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "مصدر  المؤهل",
                        value: "source",
                        sortable: false,
                        align: "start",
                    },

                    {
                        text: "الإجراءات",
                        value: "actions",
                        sortable: false,
                        align: "center",
                    },


                ],
                items: [
                    {
                        text: "ملف الموظف ",
                    },
                    {
                        text: "مؤهلات الموظف",
                    },
                ],
                totalItems: 0,
                subtitle: "مؤهلات الموظف",



                filters: {
                    page: 1,
                    pageSize: 10,
                    specialtyId: null,
                    sourceTypeId: null,
                    sourceId: null,
                    qualificationDetailsName: null,

                },

            };
        },
        methods: {
            download(id) {
                window.open(`/api/qualifications/${id}/attachment`, "_blank")
            },
            getAll(page) {
                this.filters.page = page || 1;
                this.$store.dispatch("qualifications/getQualifications", this.filters);
            },

            showDialog(item) {
                this.dialogMessage = item.qualificationDetailsName;
                this.dialog = true;
            },

            cancelDialog() {
                this.dialog = false;
                this.dialogMessage = null;
            },
            back() {
                this.view = 0;
                this.items = [
                    {
                        text: "ملف الموظف ",
                    },
                    {
                        text: "مؤهلات الموظف",
                    },
                ];
            },

        },
    };
</script>
